import { render, staticRenderFns } from "./ContactsImportTable.vue?vue&type=template&id=4b9c8677&"
import script from "./ContactsImportTable.vue?vue&type=script&lang=js&"
export * from "./ContactsImportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports